import React from "react";

const SvgHistorie = props => (
  <svg viewBox="0 0 222 209" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Obecn\xE9 ikony">
        <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h222v209H0z" />
        <path d="M111.32 10.29a94.85 94.85 0 00-90.76 95 7 7 0 1013.91 0 80.78 80.78 0 1115 46.51 7 7 0 00-11.34 8 94.71 94.71 0 1073.19-149.51z" />
        <path d="M113.67 36.24a7 7 0 00-7 6.95V108a7 7 0 0013.91 0V43.19a7 7 0 00-6.91-6.95z" />
        <path d="M113.67 101.05a7 7 0 00-4.91 11.86l45.81 45.86a7 7 0 009.86-9.87l-45.85-45.81a6.91 6.91 0 00-4.91-2.04zM25.1 123l-13-15.48c-1.2-1.42-.8-2.58.89-2.58h28.54c1.69 0 2.1 1.16.9 2.58l-13 15.48a2.72 2.72 0 01-4.33 0z" />
      </g>
    </g>
  </svg>
);

export default SvgHistorie;
